export const detailUrl = ({ customerId }) =>
  `/customers/detail/${customerId}/invoicing`;
